import React from 'react'
import MainProductList, {
  MainProductListProps,
} from 'ui-shared/WrappedInputs/MainProductList'

const RentList: React.FC<MainProductListProps> = (props) => (
  <MainProductList {...props} />
)

export default RentList
